import React from 'react';

import { useGlobalContext } from '../../../context/GlobalContext';
import { DASHBOARD_VIEW_OPTIONS, getSwitcherDashboardViews } from '../dashboardViews';
import styles from './DashboardHeader.module.scss';

export default function DashboardHeader({
  views = [],
  currentView,
  onChange,
}) {
  const [context] = useGlobalContext();
  const firstName = context.auth.userAuth?.firstName
    || context.auth.userAuth?.profile?.firstName
    || '';
  const switcherViews = getSwitcherDashboardViews(views);
  const showSwitcher = switcherViews.length > 1 && typeof onChange === 'function';
  const options = DASHBOARD_VIEW_OPTIONS.filter((option) => switcherViews.includes(option.value));
  const selectValue = options.some((option) => option.value === currentView)
    ? currentView
    : '';

  return (
    <div className={styles.header}>
      <h1 className={styles.title}>Bonjour {firstName}</h1>
      {showSwitcher && (
        <select
          className={styles.switcher}
          value={selectValue}
          aria-label="Choisir un dashboard"
          onChange={(event) => onChange(event.target.value)}
        >
          {selectValue === '' && (
            <option value="" disabled hidden />
          )}
          {options.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      )}
    </div>
  );
}
